<template lang="html">
  <section class="legals-layout take-place column">
		<div class="legals-master column">
			CGV Works
		</div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CGV.vue?2bb486b0